import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { colorPalette } from '../styles/styleGuide';
import { hex2rgb } from '../styles/utils';

// state def

var defaultState = {
  modalIsOpen: false,
  showLoader: false,
  color: hex2rgb(colorPalette.beige, 0.9),
  modalConfig: {},
  initialized: false
};

// actions

// reducer

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'MODAL_LOAD_COMPONENT':
      return _objectSpread(_objectSpread({}, state), action.payload);
    case 'MODAL_SET_INITIALIZED':
      return _objectSpread(_objectSpread({}, state), {}, {
        initialized: true
      });
    case 'MODAL_HIDE_LOADER':
      return _objectSpread(_objectSpread({}, state), {}, {
        showLoader: false
      });
    case 'MODAL_SET_DISPLAY':
      return _objectSpread(_objectSpread({}, state), {}, {
        modalIsOpen: action.payload
      });
    case 'MODAL_RESET':
      return _objectSpread({}, defaultState);
    default:
      return state;
  }
});

// action creators
export var openModal = function openModal(color, modalConfig) {
  return {
    type: 'MODAL_LOAD_COMPONENT',
    payload: {
      color: color,
      modalConfig: modalConfig,
      modalIsOpen: true,
      showLoader: false,
      initialized: false
    }
  };
};
export var openModalWithLoader = function openModalWithLoader(color, modalConfig) {
  return {
    type: 'MODAL_LOAD_COMPONENT',
    payload: {
      color: color,
      modalConfig: modalConfig,
      modalIsOpen: true,
      showLoader: true,
      initialized: false
    }
  };
};
export var updateModalOpenState = function updateModalOpenState(isOpen) {
  return {
    type: 'MODAL_SET_DISPLAY',
    payload: isOpen
  };
};
export var hideModalLoader = function hideModalLoader() {
  return {
    type: 'MODAL_HIDE_LOADER'
  };
};
export var clearModalState = function clearModalState() {
  return {
    type: 'MODAL_RESET'
  };
};
export var setModalInitialized = function setModalInitialized() {
  return {
    type: 'MODAL_SET_INITIALIZED'
  };
};